import cn from 'classnames';
import { useEffect, useRef } from 'react';
import Portal from 'react-scale/components/primitives/portal';
import { gsap } from 'gsap';

const ArrowBack = () => (
  <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.6694 9.75525H9.03161V11.7581V11.7581C9.03142 12.0347 8.77832 12.2587 8.4663 12.2586C8.33426 12.2585 8.20642 12.2174 8.10498 12.1425L3.02064 8.38937C2.78111 8.21259 2.74862 7.89718 2.94806 7.68487C2.97 7.66152 2.99429 7.63998 3.02064 7.62054L8.10498 3.86751C8.3447 3.69048 8.70095 3.71922 8.90069 3.9317C8.9852 4.02161 9.03152 4.13491 9.0316 4.25194V6.25519H14.6694C14.9809 6.25519 15.2335 6.47905 15.2335 6.75519V9.25519V9.25524C15.2335 9.53138 14.9809 9.75524 14.6694 9.75524C14.6693 9.75524 14.6693 9.75524 14.6693 9.75524L14.6694 9.75525Z" fill="white"/>
  </svg>
)

const Trash = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 6H5H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 11V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 11V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const MobileMenu = ({ isOn, handleToggle, children, ...rest }) => {
  const linksContainerRef = useRef(null);

  useEffect(() => {
    if (!linksContainerRef.current) return;

    let tween;
    if (isOn) {
      tween = gsap.to(linksContainerRef.current.children, {
        autoAlpha: 1,
        stagger: 0.04,
        delay: 0.48,
        scaleY: 1
      });
    } else {
      tween = gsap.to(linksContainerRef.current.children, {
        autoAlpha: 0,
        scaleY: 0.95
      });
    }

    return () => {
      tween?.kill();
    };
  }, [isOn]);

  useEffect(() => {
    if (isOn) {
      document.body.style.setProperty('overflow', 'hidden');
    } else {
      document.body.style.removeProperty('overflow');
    }

    return () => {
      document.body.style.removeProperty('overflow');
    };
  }, [isOn]);

  return (
    <Portal>
      <div
        className={cn('block min-w-screen max-w-none mx-0 container fixed z-50 left-0 right-0 top-0 overflow-y-auto', {
          'bottom-0 bg-black visible': isOn,
          'bottom-full bg-black/60 pointer-events-none': !isOn
        })}
        style={{
          transition:
            'background .44s .2s cubic-bezier(0.52, 0.16, 0.24, 1), bottom .56s cubic-bezier(0.52, 0.16, 0.24, 1) .2s'
        }}
        aria-hidden={!isOn}
      >
        <div className="flex flex-col py-8 text-white" ref={linksContainerRef}>
          <div className="flex justify-between mb-12">
            <button type="button" className="flex items-center space-x-2" onClick={handleToggle}>
              <ArrowBack />
              <p>Back</p>
            </button>
            <button type="button" className="flex items-center space-x-2" onClick={rest.resetFilters}>
              <p>Clear All</p>
              <Trash />
            </button>
          </div>
          <div className="space-y-12">
            {children}
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default MobileMenu;
